<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    showBooking: {
      type: Boolean,
      default: false,
    },
    bookingInfo: {
      type: Object,
      nullable: true,
    },
  },
  methods: {
    replaceBookingId(page) {
      if (!page) {
        return null;
      }
      if (this.isBookingValid) {
        if (page.params && page.params.bookingId) {
          const params = {
            bookingId: this.bookingInfo.id,
          };
          return {
            ...page,
            params,
          };
        }
      }
      return page;
    },
  },
  computed: {
    ...mapGetters({
      twentyBookingUrl: 'booking/getTwentyBookingUrl',
    }),
    isBookingValid() {
      return this.showBooking && this.bookingInfo && this.bookingInfo.id !== undefined;
    },
    headings() {
      const menus = [];
      const items = [...this.items];
      items.forEach((item, i) => {
        const menu = Object.assign({}, items[i]);
        if (this.isBookingValid) {
          menu.subheading = menu.subheading.replace(':bookingRef', this.bookingInfo.bookingRef);
        }
        menus.push(menu);
      });

      return menus;
    },
  },
};
</script>

<template>
  <v-list dense class="pt-0">
    <div
      v-for="item in headings"
      :key="item.subheading"
      v-if="(item.type === 'booking' && showBooking) || item.type === undefined">
      <v-subheader>
        <template v-if="item.type === 'booking'">
          <a :href="twentyBookingUrl" target="_blank" class="font-weight-bold">
            {{ item.subheading }}
          </a>
        </template>
        <template v-else>
          {{ item.subheading }}
        </template>
      </v-subheader>
      <div v-for="page in item.pages" :key="page.title">
        <v-list-tile
          :href="page.href || null"
          :to="replaceBookingId(page.to)"
          :exact="page.exact">
          <v-list-tile-action>
            <v-icon>{{ page.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ page.title }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="page.badge">
            <v-chip
              small
              outline
              disabled
              :color="page.badge.backgroundColor"
              :text-color="page.badge.textColor">
              {{ page.badge.text }}
            </v-chip>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile
          v-for="subpage in page.subpages"
          :key="subpage.title"
          :href="subpage.href || null"
          :to="replaceBookingId(subpage.to)"
          :exact="subpage.exact"
          class="pl-4">
          <v-list-tile-action>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ subpage.title }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="subpage.badge">
            <v-chip
              small
              outline
              disabled
              :color="subpage.badge.backgroundColor"
              :text-color="subpage.badge.textColor">
              {{ subpage.badge.text }}
            </v-chip>
          </v-list-tile-action>
        </v-list-tile>
      </div>
    </div>
  </v-list>
</template>



// WEBPACK FOOTER //
// src/components/TwNavigationList.vue